export default __webpack_public_path__ + "static/media/AssertivenessExamining.f63a18f1.png";